/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/08/2022
 */

import React, { useMemo } from "react";
import classNames from "classnames";
import CrownIcon from "../CrownIcon";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import {
  canPublishWidgetWithinQuota,
  hasRemainingWidgetQuota,
} from "../../tools";

/**
 *
 * @param {Object} props
 * @param {string} props.widgetName - The name of the widget.
 * @param {Object} props.widget - The widget object containing details like availability.
 * @param {boolean} props.isLoading - Whether the widget data is currently loading.
 * @returns {Element}
 * @constructor
 */
const WidgetName = (props) => {
  const { widgetName, widget, isLoading } = props;
  const { currentOrganization } = useCurrentOrganizationStore();

  const available = widget.available;
  const canPublish = useMemo(() => {
    return canPublishWidgetWithinQuota(
      currentOrganization,
      Boolean(widget.available)
    );
  }, [currentOrganization, widget.model]);

  const statusMobile =
    !isLoading && canPublish ? (
      <div className="widget-previously-published">
        <span
          className={classNames("d-flex", {
            "text-success": available,
            "text-secondary": !available,
          })}
        >
          <i className="material-icons">adjust</i>
          {available ? "Published" : "Unpublished"}
        </span>
      </div>
    ) : null;

  const publishCTAMobile = !canPublish ? (
    <div className={"widget-previously-published"}>
      <span className={classNames("d-flex align-items-center text-secondary")}>
        <CrownIcon className={"small mr-1"}> Upgrade to Publish</CrownIcon>
      </span>
    </div>
  ) : null;

  const previouslyPublished = widget.disabled_date ? (
    <div className={"d-flex align-items-center gap-xxs"}>
      <div className={"widget-previously-published d-flex align-items-center"}>
        <span className={"d-flex align-items-center text-danger"}>
          <i className={"material-icons"}>error</i>Previously Published
        </span>
      </div>
      <i
        className={"material-icons text-secondary cursor-pointer"}
        data-toggle={"tooltip"}
        data-placement={"bottom"}
        title={"This calendar has been unpublished because of plan downgrade."}
      >
        help
      </i>
    </div>
  ) : null;

  return (
    <div className={"widget-name--wrapper"}>
      <div className={"d-flex flex-column"}>
        <div className={"mobile-widget-name"}>{widgetName}</div>
        <div className={"d-flex mobile-widget-info"}>
          {statusMobile} {publishCTAMobile} {previouslyPublished}
        </div>
      </div>
    </div>
  );
};

export default WidgetName;
